import { Button, Text, VStack } from 'native-base';
import React, { useEffect, useImperativeHandle } from 'react';
import { PaymentComponentType } from '../types/types';

export const AfterpayComponent = React.forwardRef((props: PaymentComponentType, ref) => {
  useImperativeHandle(ref, () => ({
    confirmPayment: () => {
      const promise = new Promise((accept) => {
        const payload = JSON.stringify({
          gateway: 'afterpay',
        });

        accept(payload);
      });

      return promise;
    },
  }));

  useEffect(() => {
    props.setCardCompleted(true);

    return () => {
      props.setCardCompleted(false);
    };
  }, []);

  return (
    <VStack bg={'gray.50'} alignItems={'center'} justifyItems={'center'} p={10} space={4}>
      <Text textAlign={'center'}>
        After clicking "Place order" you will be redirected to Afterpay to complete your purchase
        securely.
      </Text>

      <Button onPress={() => Afterpay.launchModal('en_AU')} size={'sm'}>
        What is Afterpay?
      </Button>
    </VStack>
  );
});
